import React, { Component } from 'react';
//import Jumbotron from 'react-bootstrap/Jumbotron';
import '../Assests/header.css';
//import {NavbarToggler, Collapse} from 'reactstrap';
//import {Nav,Navbar, NavbarBrand,  NavLink} from 'reactstrap'
//import {GoThreeBars} from 'react-icons/go';
import keyboard from '../Assests/videos/keyboard.mp4';
import TextAnimation from 'react-animate-text';




class Header extends Component{

    render(){
        return(
          <header>
          <div class="overlay"></div>
          <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
            <source src={keyboard} type="video/mp4"/>
          </video>
          <div class="container h-100">
            <div class="d-flex h-100 text-center align-items-center">
              <div class="w-100 text-white">
                <TextAnimation>
                <h1 class="display-3">I'm Qurat-ul-ain</h1>
                <p className="p" class="lead mb-0 w-30">I'm FrontEnd Engineer</p>
                </TextAnimation>
              </div>
            </div>
          </div>
        </header>
                
               
                    
                   
                
               
         
         

        );
    }
}
export default Header;